<!-- display-mobile-19 preview — an outlined 300x195 card in the middle of an
     article: an oversized headline across the top, then the description beside a
     dark chevron button, with the disclosure badge and the advertiser name
     sitting outside the card rather than inside it. -->
<app-mobile-frame>
  <app-display-browser-chrome frameTop></app-display-browser-chrome>

  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- Article text the ad is embedded in -->
    <div class="da-bars d-flex flex-column">
      <span
        *ngFor="let bar of topBars; let last = last"
        class="da-bar placeholder"
        [class.da-bar-short]="last"
      ></span>
    </div>

    <!-- START: Real ad -->
    <div class="da-ad">
      <!-- The mock draws no creative in this placement, so data.image has
           nowhere to go: the unit is all type plus the action button. -->
      <div class="da-unit d-flex flex-column">
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
          {{ data.headlines[0] || "Your headline appears here" }}
        </a>

        <div class="da-row d-flex flex-row align-items-center">
          <div class="da-desc">
            {{ data.descriptions[0] || "Your description appears here" }}
          </div>

          <a
            [href]="data.url" target="_blank" rel="noopener noreferrer"
            class="da-cta d-flex align-items-center justify-content-center"
            aria-label="Open"
          >
            <i class="bi bi-chevron-right"></i>
          </a>
        </div>
      </div>

      <!-- Below the card, not inside it — the network's own chrome, drawn on the
           page rather than on the unit. -->
      <div class="da-footer d-flex flex-row align-items-center">
        <span
          class="da-adchoices d-flex align-items-center justify-content-center"
          aria-hidden="true"
        >
          <i class="bi bi-info-circle"></i>
        </span>

        <!-- GenSingleImagePreviewData carries no advertiser field, so the name
             is a literal here, the same compromise the other placements make. -->
        <span class="da-advertiser ms-auto">Valamar</span>
      </div>
    </div>
    <!-- END: Real ad -->

    <!-- Article text continuing below the ad; the last rows clip at the frame -->
    <div class="da-bars d-flex flex-column">
      <span *ngFor="let bar of bottomBars" class="da-bar placeholder"></span>
    </div>
  </div>
  <!-- END: Publisher page -->
</app-mobile-frame>
